.skin-business {
  &.zeudy-player__wrapper {
    // when small play button is active but rewind is inactive
    &.rewind-inactive {
      .plyr__controls .plyr__controls__item:nth-child(2) {
        &::before {
          border-radius: var(--plyr-control-radius, 3px) 0px 0px var(--plyr-control-radius, 3px);
        }
      }
    }

    // full captions
    &.caption-style-full .plyr:not(.plyr--hide-controls):not(.is-muted-overlay) .plyr__controls:not(:empty) ~ .plyr__captions {
      transform: translateY(calc(var(--plyr-control-spacing, 16px) * -4));
    }

    .zeudy-player-progress__marker {
      border-radius: 0;
      width: 15px;
      height: 15px;
      border-width: 1px;
    }

    // hover effect for all button
    .plyr__control[data-plyr] {
      &:hover,
      &:focus,
      &:active {
        &:not([role*='menuitem']):not(.plyr__control--back) {
          background-color: transparent;
          color: var(--plyr-color-main);

          &[data-plyr='play'] {
            background-color: var(--plyr-color-main);
            color: white;
          }
        }
      }
    }

    // for large button
    .plyr__control--overlaid[data-plyr='play'] {
      border-radius: 4px;
      background: #000000;
      opacity: 75%;
      &:hover {
        background-color: var(--plyr-color-main);
        color: white;
        opacity: 100%;
      }
    }

    // for soun range cursor
    .plyr__volume input[type='range'] {
      cursor: pointer;
    }

    // fast forward
    .plyr__controls .plyr__controls__item[data-plyr='fast-forward'] {
      border-radius: 0px;
    }

    // range contol for video progression
    .plyr__progress {
      margin: 0px 20px 0 5px;

      input[type='range'] {
        height: 32px;
        border-radius: 0px;
        cursor: pointer;
      }
    }

    .plyr__controls .plyr__controls__item:not(.zeudy-player-progress__marker):first-child {
      &::before {
        border-radius: var(--plyr-control-radius, 3px) 0px 0px var(--plyr-control-radius, 3px);
      }
    }
    .plyr__controls .plyr__controls__item:not(.zeudy-player-progress__marker):last-child {
      &::before {
        border-radius: 0px var(--plyr-control-radius, 3px) var(--plyr-control-radius, 3px) 0px;
      }
    }

    // play button
    .plyr__controls .plyr__controls__item.plyr__control[data-plyr='play'] {
      order: -1;
      margin-right: 5px;
      padding: 11px 20px 11px 20px;
      top: -4px;
      &::before {
        border-radius: 4px;
      }
    }

    // rewind control
    .plyr__controls .plyr__controls__item[data-plyr='rewind'] {
      &::before {
        border-radius: var(--plyr-control-radius, 3px) 0px 0px var(--plyr-control-radius, 3px);
      }
    }

    .plyr__controls .plyr__controls__item:not([data-plyr='play']) {
      margin: 0;
    }

    //make fullscreen svg bigger
    .plyr__controls .plyr__controls__item[data-plyr='fullscreen'] {
      padding: 4px;
      svg {
        height: 24px;
        width: 24px;
      }
    }

    .plyr__controls .plyr__controls__item:not(.zeudy-player-progress__marker) {
      position: relative;
      // time
      &.plyr__time {
        height: 32px;
        padding-top: 4.5px;
      }

      &::before {
        content: '';
        background: #000000;
        position: absolute;
        top: 0px;
        left: 0;
        right: 0;
        bottom: 0px;
        opacity: 0.76;
        z-index: -1;
      }
    }

    // make video prgression range outline
    .plyr--full-ui input[type='range']::-webkit-slider-runnable-track {
      box-shadow: none;
      color: var(--plyr-color-main);
      height: 9px;
      outline: 1px solid #878787a6;
      outline-offset: 2px;
      border-radius: 0px;
    }

    // make the range control invisible
    .plyr--full-ui input[type='range']::-webkit-slider-thumb {
      visibility: hidden;
    }

    // make buffer big
    .plyr__progress__buffer::-webkit-progress-value {
      position: relative;
      border-radius: 0px;
      height: 9px;
      top: -2px;
    }

    .plyr--full-ui input[type='range']::-webkit-slider-runnable-track {
      background-color: transparent;
    }

    @media screen and (max-width: 480px) {
      .plyr__controls .plyr__controls__item {
        &.plyr__time {
          padding: 1.5%;
        }
      }
      .plyr__controls .plyr__controls__item[data-plyr='play'] {
        padding: 8px;
        top: 0px;
      }
      //make fullscreen svg bigger
      .plyr__controls .plyr__controls__item[data-plyr='fullscreen'] {
        svg {
          width: 22px;
        }
      }
    }
  }
}
